import * as auth from './auth.json';

export default {
  auth,
};



// WEBPACK FOOTER //
// ./src/app/locale/nl/index.js